import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForRequestConfirmed = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtRequestConfirmed($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtRequestConfirmed(input: $input) {
			userErrors
			success
		}
	}
`);
